<template>
  <section class="users-table">
    <div v-if="shouldShowFilters && showFilters" class="users-table-filters row">
      <div class="col-12 col-md-4">
        <label class="form-label">{{$t('users.inputs.entity')}}</label>
        <multiselect
          v-model="filters.entity"
          :options="readableEntities"
          track-by="id"
          label="name"
          select-label=""
          selected-label=""
          deselect-label=""
          :placeholder="$t('statistics.select_entity')"
          :allow-empty="true"
          :multiple="false"
          :searchable="true"
          >
            <template slot="clear" slot-scope="props">
              <div class="multiselect__clear" v-if="filters.entity" @mousedown.prevent.stop="filters.entity = null"></div>
            </template>
          </multiselect>
      </div>
    </div>

    <v-server-table
      :id="tableName"
      :ref="tableName"
      :name="tableName"
      :columns="columns"
      :options="tableOptions"
      @row-click="onRowClicked"
    >
      <span slot="h__name">{{$t('users.inputs.name')}}</span>
      <span slot="h__entity">{{$t('users.inputs.entity')}}</span>
      <span slot="active_status" slot-scope="props">
        <span class="small-status-icon align-middle mr-1"
              :class="{'i-evollu-status-active': props.row.blocked_at === null, 'i-evollu-status-inactive': props.row.blocked_at !== null}">
        </span>
        {{ props.row.blocked_at ? $t('no') : $t('yes') }}
      </span>
    </v-server-table>
  </section>
</template>

<script>
import TableQueryMixin from '@/mixins/TableQueryMixin'
import Multiselect from 'vue-multiselect'

const usersInfoType = 100
const readAccessType = 1

export default {
  components: {
    Multiselect
  },
  mixins: [
    TableQueryMixin
  ],
  props: {
    saveState: {
      type: Boolean,
      required: false,
      default: true
    },
    tableName: {
      type: String,
      required: true
    },
    customQueries: {
      type: Object,
      required: false
    },
    entity: {
      type: Object,
      required: false
    },
    querySearch: {
      type: String,
      required: false
    },
    showFilters: {
      type: Boolean,
      required: false,
    },
    shouldShowFilters: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  created: function () {
    if (this.entity) {
      this.tableOptions.initFilters.entity = this.entity.id
    } else if (this.customQueries && this.customQueries.entity) {
      this.tableOptions.initFilters.entity = this.customQueries.entity
      this.filters.entity = this.readableEntities.find(ent => ent.id === this.customQueries.entity) || null
    }
  },
  data () {
    return {
      filters: {
        entity: null,
        querySearch: null
      },
      columns: ['name', 'email', 'nickname', 'entity', 'active_status'],
      queryUrl: this.$store.state.evollauth_server + '/users',
      tableOptions: {
        columnsDropdown: false,
        saveState: this.saveState,
        filterable: ['name', 'email', 'entity'],
        sortable: ['name', 'email', 'entity'],
        headings: {
          email: 'E-mail',
          nickname: this.$t('users.nickname'),
          active_status: this.$t('users.active_status')
        },
        customFilters: ['entity'],
        initFilters: {
          entity: ''
        }
      },
    }
  },
  computed: {
    authService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.evollauth_server) || null
    },
    readableEntities: function () {
      if (this.authService) {
        let permissions = this.authService.user_permissions.filter(p => p.info_type === usersInfoType && p.access_type >= readAccessType)

        if (permissions.some(p => p.entity_id === null)) {
          return [...this.authService.entities]
        } else {
          return this.authService.entities.filter(entity => permissions.some(p => p.entity_id === entity.id))
        }
      }
      return []
    },
    activeFilterCount: function () {
      let count = 0
      if (this.filters.entity !== null && this.filters.entity !== undefined) count++
      return count
    }
  },
  methods: {
    onRowClicked: function ({ row }) {
      this.$router.push({
        name: `${this.authService.slug}users/id`,
        params: { id: row.id },
        props: { service: this.authService }
      })
    },
    refresh: function () {
      this.$refs[this.tableName].refresh()
    },
    getTableReference: function () {
      return this.$refs[this.tableName]
    }
  },
  watch: {
    entity: {
      handler: function (entity) {
        this.filters.entity = entity
      },
      immediate: true
    },
    querySearch: {
      handler: function (value) {
        this.filters.querySearch = value || ''
      },
      immediate: true
    },
    'filters.entity': function (value) {
      this.emitTableFilter(`vue-tables.${this.tableName}.filter::entity`, value ? value.id : '')
      this.$emit('filters-updated', { filters: this.filters, count: this.activeFilterCount })
    },
    'filters.querySearch': function (value) {
      this.$refs[this.tableName].setFilter(value)
      this.$emit('filters-updated', { filters: this.filters, count: this.activeFilterCount })
    }
  }
}
</script>

<style lang="scss">

#usersTable {
  .VueTables__search {
    display: none;
  }
}

</style>
